/* VOLT landing system JS
   - PDP pack (variant) cards, qty stepper, gallery thumbs
   - Syncs any [data-vlt-cta-atc] banner to the selected variant
   Works with the theme's <product-form> (assets/product-form.js) so the
   cart drawer + Magic Checkout flow stays untouched. */
(function () {
  'use strict';

  function parseJSON(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fill(tpl, v) {
    return (tpl || '')
      .replace(/\[price\]/g, v.price)
      .replace(/\[pack\]/g, v.title)
      .replace(/\[per_serve\]/g, v.per_serve || '');
  }

  /* ---------- PDP ---------- */
  function initPdp(root) {
    if (!root || root.dataset.vltReady) return;
    root.dataset.vltReady = 'true';

    var dataEl = root.querySelector('[data-vlt-variants]');
    var variants = dataEl ? parseJSON(dataEl) : null;
    if (!variants) return;

    var idInput = root.querySelector('form input[name="id"]');
    var priceEl = root.querySelector('[data-vlt-price]');
    var compareEl = root.querySelector('[data-vlt-compare]');
    var perEl = root.querySelector('[data-vlt-per]');
    var addBtn = root.querySelector('button[name="add"]');
    var addLabel = addBtn ? addBtn.querySelector('span') : null;
    var labelTpl = root.dataset.addLabel || 'Add to cart';
    var soldOut = root.dataset.soldOut || 'Sold out';

    function select(id) {
      var v = variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      var packLabel = root.querySelector('[data-vlt-pack-label]'); if (packLabel) packLabel.textContent = v.title;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !v.compare; }
      if (perEl) { perEl.textContent = v.per_serve ? v.per_serve + '/serve' : ''; perEl.hidden = !v.per_serve; }

      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.removeAttribute('aria-disabled');
        if (addLabel) { addLabel.classList.remove('hidden'); addLabel.textContent = v.available ? fill(labelTpl, v) : soldOut; }
      }

      if (v.media_id) showSlide(String(v.media_id));

      if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(new CustomEvent('vlt:variant-change', { detail: { productId: root.dataset.productId, variant: v } }));
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-vlt-pack]')) select(e.target.value);
    });

    /* qty */
    var qty = root.querySelector('[data-vlt-qty] input');
    root.querySelectorAll('[data-vlt-qty] button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var n = parseInt(qty.value, 10) || 1;
        n = b.dataset.step === 'up' ? n + 1 : Math.max(1, n - 1);
        qty.value = n;
      });
    });

    /* gallery + thumbnail carousel */
    var slides = root.querySelectorAll('[data-vlt-slide]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-vlt-thumb]'));
    var track = root.querySelector('[data-vlt-thumbs]');
    var wrap = root.querySelector('[data-vlt-thumbs-wrap]');
    var navPrev = root.querySelector('[data-vlt-thumb-nav="prev"]');
    var navNext = root.querySelector('[data-vlt-thumb-nav="next"]');

    function activeIndex() {
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) return i; }
      return 0;
    }

    function centerThumb(t) {
      if (!track || !t) return;
      var left = t.offsetLeft - (track.clientWidth - t.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }

    function updateNav() {
      if (!wrap || !track) return;
      wrap.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 1);
      var i = activeIndex();
      if (navPrev) navPrev.disabled = i <= 0;
      if (navNext) navNext.disabled = i >= thumbs.length - 1;
    }

    function showSlide(mediaId) {
      var found = false;
      slides.forEach(function (s) { if (s.dataset.vltSlide === mediaId) found = true; });
      if (!found) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.vltSlide === mediaId); });
      thumbs.forEach(function (t) {
        var on = t.dataset.vltThumb === mediaId;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) centerThumb(t);
      });
      updateNav();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showSlide(t.dataset.vltThumb); });
    });
    [navPrev, navNext].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        var i = activeIndex() + (btn === navNext ? 1 : -1);
        if (thumbs[i]) showSlide(thumbs[i].dataset.vltThumb);
      });
    });
    if (track) {
      updateNav();
      centerThumb(thumbs[activeIndex()]);
      if ('ResizeObserver' in window) new ResizeObserver(updateNav).observe(track);
      else window.addEventListener('resize', updateNav);
    }

    var checked = root.querySelector('[data-vlt-pack]:checked');
    if (checked) {
      /* announce initial variant so CTA banners sync on load */
      var v0 = variants.find(function (x) { return String(x.id) === String(checked.value); });
      if (v0) document.dispatchEvent(new CustomEvent('vlt:variant-change', { detail: { productId: root.dataset.productId, variant: v0 } }));
    }
  }

  /* ---------- CTA banner sync ---------- */
  document.addEventListener('vlt:variant-change', function (e) {
    var d = e.detail || {};
    if (!d.variant) return;
    document.querySelectorAll('[data-vlt-cta-atc]').forEach(function (cta) {
      if (cta.dataset.productId && String(cta.dataset.productId) !== String(d.productId)) return;
      var v = d.variant;
      var input = cta.querySelector('form input[name="id"]');
      var btn = cta.querySelector('button[name="add"]');
      var label = btn ? btn.querySelector('span') : null;
      var note = cta.querySelector('[data-vlt-cta-note]');
      if (input) input.value = v.id;
      if (btn) { btn.disabled = !v.available; btn.removeAttribute('aria-disabled'); }
      if (label) { label.classList.remove('hidden'); label.textContent = v.available ? fill(cta.dataset.labelTpl, v) : (cta.dataset.soldOut || 'Sold out'); }
      if (note && cta.dataset.noteTpl) note.textContent = fill(cta.dataset.noteTpl, v);
    });
  });

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vlt-pdp]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
